import { useState } from "react";
import { rankItems } from "@/mocks/communityData";
import SectionTitle from "./SectionTitle";

export default function Ranking() {
  const [voted, setVoted] = useState<number | null>(null);

  const medColor = (d: number) => (d > 0 ? "text-accent-600" : d < 0 ? "text-primary-500" : "text-foreground-400");
  const rankStyle = (r: number) =>
    r === 1 ? "bg-primary-500 text-background-50" : r === 2 ? "bg-secondary-500 text-background-50" : r === 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600";

  return (
    <section id="rank" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionTitle
          eyebrow="热议排行"
          title="热议排行榜 · 全网最火的都在前头"
          desc="按实时讨论量滚动更新的热度榜单，看看今天大家都在围观什么。"
        />

        <div className="mx-auto max-w-3xl overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          {rankItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 px-4 py-3.5 transition hover:bg-background-100 md:px-5 ${
                idx !== rankItems.length - 1 ? "border-b border-background-100" : ""
              }`}
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-bold ${rankStyle(item.rank)}`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-medium text-foreground-900 md:text-base">{item.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-400">{item.comments} 人正在讨论</p>
              </div>
              <span className={`hidden items-center gap-0.5 text-xs font-medium sm:flex ${medColor(item.delta)}`}>
                <i className={`${item.delta >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line"} text-sm`} aria-hidden="true"></i>
                {Math.abs(item.delta)}
              </span>
              <button
                type="button"
                aria-label={voted === item.rank ? "已投过票" : "为这个话题投票"}
                onClick={() => setVoted(item.rank)}
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition ${
                  voted === item.rank
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-500 hover:bg-primary-100/70"
                }`}
              >
                <i className={`${voted === item.rank ? "ri-fire-fill" : "ri-add-line"} text-base`} aria-hidden="true"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}